import { Injectable } from '@angular/core';
import { Router, NavigationStart, NavigationEnd, NavigationCancel, NavigationError } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { filter, debounceTime } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class NavigationSpinnerService {
  private readonly NAV_DEBOUNCE_MS = 80;

  constructor(router: Router, spinner: NgxSpinnerService) {
    router.events
      .pipe(filter(e => e instanceof NavigationStart), debounceTime(this.NAV_DEBOUNCE_MS))
      .subscribe(() => spinner.show());

    router.events
      .pipe(filter(e => e instanceof NavigationEnd || e instanceof NavigationCancel || e instanceof NavigationError))
      .subscribe(() => spinner.hide());
  }
}
